import { z } from 'zod';

import { Role } from '../../enums/generated/role';

// `status` is a UI-only representation of the boolean `isActive` field (the form
// maps it back to isActive on submit), so it stays a plain string. `roles` is a
// single-select whose options are members of the Role enum.
export const AdminModalUserManagementFormSchema = z.object({
  status: z.string(),
  roles: z.nativeEnum(Role),
});

export type AdminModalUserManagementFormValues = z.infer<
  typeof AdminModalUserManagementFormSchema
>;
